module.exports = __webpack_public_path__ + "static/img/icon1_active.56b1f2a1.svg";